import format from 'date-fns/format';
import queryString from 'query-string';
/* location : 시간 포맷팅 */
export const formatToRequestParameter = (params: object) =>
  queryString.stringify(params);

export const formatToSearchQueryObject = (query: string) =>
  queryString.parse(query);

export const formatWithComma = (num: number) =>
  String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatStringToDate = (
  date: string,
  formatting = 'yyyy-MM-dd HH:mm'
) => {
  const newDate = new Date(date);
  if (newDate.toString() === 'Invalid Date') return 'Invalid Date';
  return format(newDate, formatting);
};

export const extractTimeFromKST = (
  kstString: string,
  formatting = 'HH:mm'
): string => {
  // '[Asia/Seoul]' 부분을 제거합니다.
  const cleanedKSTString = kstString.replace(/\[Asia\/Seoul\]$/, '');

  const newDate = new Date(cleanedKSTString);
  if (newDate.toString() === 'Invalid Date') return 'Invalid Date';

  return format(newDate, formatting);
};

export const formatTimeStrToNum = (time: string) => {
  const hh = Number(time.slice(0, 2));
  const mm = Number(time.slice(3, 5));
  const apm = time.slice(6);

  if (apm === 'PM') return (hh + 12) * 60 + mm;
  else return hh * 60 + mm;
};

// yyyy-mm-dd hh:mm AM/PM 형식으로 변환
export const formatDate = (isoDate: string) => {
  // Date 객체 생성
  const date = new Date(isoDate);

  // 날짜와 시간 추출
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');

  // 12시간제 계산
  const period = hours >= 12 ? 'PM' : 'AM';
  const adjustedHours = hours % 12 || 12; // 0시는 12로 표시

  // 형식 조합
  return `${year}-${month}-${day} ${adjustedHours}:${minutes} ${period}`;
};
